
























































































































import {Component, Vue} from 'vue-property-decorator';
import pomocLogowanie1 from '../../assets/pomoc-logowanie/pomoc-logowanie-1.png';
import pomocLogowanie2 from '../../assets/pomoc-logowanie/pomoc-logowanie-2.png';
import pomocLogowanie3 from '../../assets/pomoc-logowanie/pomoc-logowanie-3.png';
import pomocLogowanie4 from '../../assets/pomoc-logowanie/pomoc-logowanie-4.png';
import pomocBrakmMiejsc from '../../assets/pomoc-logowanie/pomoc-brak-miejsc.png';

@Component
export default class LoginFaq extends Vue {
  private pomocLogowanie1 = pomocLogowanie1;
  private pomocLogowanie2 = pomocLogowanie2;
  private pomocLogowanie3 = pomocLogowanie3;
  private pomocLogowanie4 = pomocLogowanie4;
  private pomocBrakmMiejsc = pomocBrakmMiejsc;

  private docsLink = `${process.env.VUE_APP_API_URL}/docs`;

}
